import { createAction, props } from '@ngrx/store';
import { CityDto } from 'src/app/api/models';

export const loadCitysByProvince = createAction(
  '[City] Load City by province',
  props<{ provinceId: number }>()
);

export const loadCitysByProvinceSuccess = createAction(
  '[City] Load City by province Success',
  props<{ data: CityDto[] }>()
);

export const loadCitysByProvinceFailure = createAction(
  '[City] Load City by province Failure',
  props<{ error: any }>()
);


export const resetCity = createAction("[City] Reset");